<template>
  <v-card outlined>

    <c-expansion-panel>
      <template v-slot:header="{ expand }">

        <v-row class="pa-3 align-center border-b--thin backgroundCard">
          <img class="mr-3" src="@/assets/img/illustrations/cream.png" height="40px" width="40px" />

          <div>
            
            Custom Rows

            <div>
              <template v-if="misc_items.length > 1">
                <span class="overline">
                  {{ misc_items.length }} ITEMS
                </span>
              </template>
            </div>
          </div>
          <v-spacer></v-spacer>
         

          <v-icon :class="{'rotate-180': expand}">mdi-chevron-down</v-icon>
        </v-row>

      </template>
      <template v-slot:body>


        <div class="">
            <!--
            <list-row
            v-for="item in item.items"
            vmode="group"
            :key="item.tempID"
            :item="item"
            :reserved="(savedInputs.find(row => row.id === item.id) || {}).quantity"
            :inventoryView="inventoryView"
            :mergeMap="mergeMap"
            :selected="selected"
            :searchFilters="searchFilters"
            :showAllBoxesMode="showAllBoxesMode"
            :boxOrderIDMap="boxOrderIDMap"
            class="caption"
            @checkRow="$emit('checkRow', item)"
            ></list-row>
            -->

            <list-row
            v-for="item in misc_items"
            :key="item.id"
            :item="item"
            :reserved="(savedInputs.find(row => row.id === item.id) || {}).quantity"
            :selected="selected"
            :savedInputs="savedInputs"
            :mergeMap="mergeMap"
            :inventoryView="inventoryView"
            :searchFilters="searchFilters"
            :showAllBoxesMode="showAllBoxesMode"
            :boxOrderIDMap="boxOrderIDMap"
            class="ma-2"
            @checkRow="$emit('checkRow', $event)"
            ></list-row>

        </div>
      </template>
    </c-expansion-panel>
  
  </v-card>
</template>

<script>
import TextHighlight from 'vue-text-highlight'
import ListRow from "./group-row"

export default {
  data () {
    return {
    }
  },
  props: {
    custom_items: null,
    selected: null,
    savedInputs: null,
    mergeMap: null,
    inventoryView: null,
    searchFilters: null,
    showAllBoxesMode: null,
    boxOrderIDMap: null
  },
  components: {
    ListRow,
    TextHighlight
  },
  computed: {
    misc_items () {
      return Object.values(this.custom_items)
    },
    nameKeywords () {
      return (this.searchFilters.name || '').trim().split(/\s+/)
    },
    totalQuantity () {
      return this.item.items.reduce((a, i) => a + i.quantity, 0)
    }
  },
  methods: {
  }
}
</script>